module.exports = __webpack_public_path__ + "static/media/multihand-blackjack.9e143e16.gif";